// When a form is rendered with validation errors, scroll to the first field with an error.
//
// This is bound to the form on purpose, not to the fields with errors: Unpoly's validation
// ([up-validate]) only re-renders fragments *within* the form, and those must not scroll the page
// whenever a re-rendered fragment happens to contain an error.
const ERROR_SELECTORS = [
  '.form-group.has-danger',
  '.form-check.has-danger',
  '.form-control.has-danger',
]

up.compiler('form', (form) => {
  const firstFieldWithError = form.querySelector(ERROR_SELECTORS.join(', '))
  if (!firstFieldWithError) return

  setTimeout(() => {
    up.reveal(firstFieldWithError)
  })
})
